import * as wjCore from '@mescius/wijmo'

export default function editableFlexGridInitialize (grid, isMultiRow = true) {
  grid.selectionChanged.addHandler((g, e) => {
    const column = isMultiRow ? grid.getBindingColumn(e.panel, e.row, e.col) : grid.getColumn(e.col)

    if (column.isReadOnly) {
      // grid.collectionView.collectionChanged.raise()すると何故かaタグのクリックが反応しないため、
      // aタグが存在するセルのクリック時は即座に抜ける
      const linkElems = $(g.activeCell).find('a, button')
      if (linkElems.length > 0) {
        return
      }
    }

    // マウスクリックによる選択の変更ではcollectionChangedが発生しないので手動でraiseする
    grid.collectionView.collectionChanged.raise(grid.collectionView)

    // 文字列入力セルを選択した場合は即座に編集モードにする（1文字目に日本語入力モードが適用されないため）
    if (!column.isReadOnly && column.dataType === wjCore.DataType.String) {
      grid.startEditing(true, e.row, e.col)
    }
  })
  grid.hostElement.addEventListener('keydown', (e) => {
    if (e.keyCode === wjCore.Key.Delete) {
      // Deleteキーを押すと該当セルの値を消去する
      const cell = grid.activeCell['wj-cell-index']
      const column = isMultiRow ? grid.getBindingColumn(cell.panel, cell.row, cell.col) : grid.getColumn(cell.col)
      if (!column.isReadOnly) {
        switch (column.dataType) {
          case wjCore.DataType.Number:
            grid.setCellData(cell.row, cell.col, 0)
            break
          case wjCore.DataType.String:
            grid.setCellData(cell.row, cell.col, '')
            break
          case wjCore.DataType.Boolean:
            grid.setCellData(cell.row, cell.col, false)
            break
          default:
            break
        }
      }
    }
  }, true)
}
